import React, { Component } from 'react';
import { AbstractChart } from 'containers/charts/AbstractChart';
import { withTheme } from 'styled-components';
import { isEqual } from 'lodash';
import ContentTile from 'components/atoms/layout/ContentTile';
import ContentHeader from 'components/atoms/layout/ContentHeader';
import helpers from 'helpers';

class LayerTwoActivitiesStackedBarChart extends Component {
    constructor(props) {
        super(props);
        this.chartRef = React.createRef();
    }

    shouldComponentUpdate(nextProps) {
        if (isEqual(nextProps.data, this.props.data)) {
            return false;
        }
        return true;
    }

    render() {
        const series = [];
        const { chartRef } = this;
        const { orderedColors } = this.props.theme;
        this.props.rankings[this.props.y].forEach((ele, index) => {
            series.push({
                name: ele.name,
                color: orderedColors[index % orderedColors.length],
                data: this.props.data[ele.name].items.map(r => ({
                    x: r.date_in_ms,
                    y: r[this.props.y]
                }))
            });
        });
        series.reverse();

        const xAxis = helpers.xAxisConfig({
            type: 'datetime',
            xAxisLabel: this.props.xAxisLabel
        });

        const yAxis = helpers.yAxisConfig({
            yAxisLabel: this.props.yAxisLabel || 'Activities'
        });

        const plotOptions = {
            series: {
                animation: {
                    duration: this.props.animateDuration,
                }
            },
            column: {
                stacking: 'normal',
                borderWidth: 0
            }
        };

        return (
            <ContentTile padding={helpers.contentPadding('chart-with-legend')}>
                <ContentHeader chartRef={chartRef} type={'chart'}>{this.props.title}</ContentHeader>
                <AbstractChart
                    ref={chartRef}
                    exportName={this.props.exportName}
                    config={{
                        meta: {
                            title: this.props.title
                        },
                        chart: {
                            type: 'column'
                        },
                        exporting: helpers.commonExportingConfig(this.props.exportName),
                        credits: {
                            enabled: false
                        },
                        plotOptions,
                        title: {
                            text: null
                        },
                        tooltip: {
                            split: true,
                            crosshairs: {
                                width: 1,
                                color: 'gray',
                                dashStyle: 'shortdot'
                            }
                        },
                        legend: {
                            itemStyle: {
                                color: this.props.theme.charts.axisAssets
                            }
                        },
                        xAxis,
                        yAxis,
                        series
                    }} />
            </ContentTile>
        );
    }
}

export default withTheme(LayerTwoActivitiesStackedBarChart);



// WEBPACK FOOTER //
// ./src/components/molecules/charts/LayerTwoActivitiesStackedBarChart.js